// File Metadata:
// Filename: TimerIndicator.jsx
// Version: 1.00
// Created: 2026-06-14
// Last Modified: 2026-06-14
// Authors: GitHub Copilot
// Description: Timer indicator chip component for displaying active timer state in the Navbar

import React from 'react';
import { Chip } from '@mui/material';
import TimerIcon from '@mui/icons-material/Timer';
import { alpha, useTheme } from '@mui/material/styles';
import { Link } from 'react-router-dom';

const TimerIndicator = ({ isDark, formattedTime }) => {
  const theme = useTheme();
  
  const desktopChip = (
    <Chip
      icon={<TimerIcon fontSize="small" />}
      label={formattedTime}
      component={Link}
      to="/timer"
      clickable
      sx={{
        mr: 0.5,
        fontWeight: 700,
        fontFamily: "'Bricolage Grotesque', monospace",
        fontSize: '0.8rem',
        height: 32,
        minWidth: 64, // Fixed width to prevent layout shifts
        justifyContent: 'center',
        bgcolor: isDark ? alpha(theme.palette.warning.main, 0.15) : alpha(theme.palette.warning.main, 0.1),
        color: theme.palette.warning.main,
        borderColor: theme.palette.warning.main,
        border: '1px solid',
        '&:hover': {
          bgcolor: isDark ? alpha(theme.palette.warning.main, 0.25) : alpha(theme.palette.warning.main, 0.2),
        },
      }}
    />
  );

  const mobileChip = (
    <Chip
      icon={<TimerIcon fontSize="small" />}
      label={formattedTime}
      component={Link}
      to="/timer"
      clickable
      sx={{
        display: { xs: 'flex', md: 'none' },
        mr: 0.5,
        fontWeight: 700,
        fontFamily: "'Bricolage Grotesque', monospace",
        fontSize: '0.7rem',
        height: 28,
        minWidth: 56, // Fixed width to prevent layout shifts
        justifyContent: 'center',
        bgcolor: isDark ? alpha(theme.palette.warning.main, 0.15) : alpha(theme.palette.warning.main, 0.1),
        color: theme.palette.warning.main,
        border: '1px solid',
        borderColor: theme.palette.warning.main,
      }}
    />
  );

  return (
    <>
      {desktopChip}
      {mobileChip}
    </>
  );
};

export default TimerIndicator;
